import { default as _91slug_93OfOft3wYwjMeta } from "/media/saeid/projects/Athena/client/app/pages/(website)/blogs/[slug].vue?macro=true";
import { default as indexG78aEh00g0Meta } from "/media/saeid/projects/Athena/client/app/pages/(website)/blogs/index.vue?macro=true";
import { default as indexoLfrESkdhmMeta } from "/media/saeid/projects/Athena/client/app/pages/(website)/index.vue?macro=true";
import { default as default_45promptXZkYbLRw0MMeta } from "/media/saeid/projects/Athena/client/app/pages/app/default-prompt.vue?macro=true";
import { default as historyScyl2IVSJ7Meta } from "/media/saeid/projects/Athena/client/app/pages/app/history.vue?macro=true";
import { default as indexZYhpYzVG2iMeta } from "/media/saeid/projects/Athena/client/app/pages/app/index.vue?macro=true";
import { default as loginn6HMaqiRjFMeta } from "/media/saeid/projects/Athena/client/app/pages/app/login.vue?macro=true";
import { default as onboardPFAKx4kHYFMeta } from "/media/saeid/projects/Athena/client/app/pages/app/onboard.vue?macro=true";
import { default as indexpJSjxhPlCpMeta } from "/media/saeid/projects/Athena/client/app/pages/app/payment-status/index.vue?macro=true";
import { default as profilejVCj46DFI4Meta } from "/media/saeid/projects/Athena/client/app/pages/app/profile.vue?macro=true";
import { default as purchase_45confirmKgV7vNhBCUMeta } from "/media/saeid/projects/Athena/client/app/pages/app/purchase-confirm.vue?macro=true";
import { default as subscriptionDqJm9G0WO5Meta } from "/media/saeid/projects/Athena/client/app/pages/app/subscription.vue?macro=true";
import { default as indext2nhA8kxkKMeta } from "/media/saeid/projects/Athena/client/app/pages/panel/default-model/index.vue?macro=true";
import { default as index82UtF9N8oEMeta } from "/media/saeid/projects/Athena/client/app/pages/panel/index.vue?macro=true";
import { default as addtbRCc3tf7NMeta } from "/media/saeid/projects/Athena/client/app/pages/panel/prompt/add.vue?macro=true";
import { default as indexgCNVGbJTfaMeta } from "/media/saeid/projects/Athena/client/app/pages/panel/prompt/index.vue?macro=true";
export default [
  {
    name: "blogs-slug",
    path: "/blogs/:slug()",
    meta: _91slug_93OfOft3wYwjMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/(website)/blogs/[slug].vue").then(m => m.default || m)
  },
  {
    name: "blogs",
    path: "/blogs",
    meta: indexG78aEh00g0Meta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/(website)/blogs/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexoLfrESkdhmMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/(website)/index.vue").then(m => m.default || m)
  },
  {
    name: "app-default-prompt",
    path: "/app/default-prompt",
    meta: default_45promptXZkYbLRw0MMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/app/default-prompt.vue").then(m => m.default || m)
  },
  {
    name: "app-history",
    path: "/app/history",
    meta: historyScyl2IVSJ7Meta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/app/history.vue").then(m => m.default || m)
  },
  {
    name: "app",
    path: "/app",
    meta: indexZYhpYzVG2iMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/app/index.vue").then(m => m.default || m)
  },
  {
    name: "app-login",
    path: "/app/login",
    meta: loginn6HMaqiRjFMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/app/login.vue").then(m => m.default || m)
  },
  {
    name: "app-onboard",
    path: "/app/onboard",
    meta: onboardPFAKx4kHYFMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/app/onboard.vue").then(m => m.default || m)
  },
  {
    name: "app-payment-status",
    path: "/app/payment-status",
    component: () => import("/media/saeid/projects/Athena/client/app/pages/app/payment-status/index.vue").then(m => m.default || m)
  },
  {
    name: "app-profile",
    path: "/app/profile",
    meta: profilejVCj46DFI4Meta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/app/profile.vue").then(m => m.default || m)
  },
  {
    name: "app-purchase-confirm",
    path: "/app/purchase-confirm",
    meta: purchase_45confirmKgV7vNhBCUMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/app/purchase-confirm.vue").then(m => m.default || m)
  },
  {
    name: "app-subscription",
    path: "/app/subscription",
    meta: subscriptionDqJm9G0WO5Meta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/app/subscription.vue").then(m => m.default || m)
  },
  {
    name: "panel-default-model",
    path: "/panel/default-model",
    meta: indext2nhA8kxkKMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/panel/default-model/index.vue").then(m => m.default || m)
  },
  {
    name: "panel",
    path: "/panel",
    meta: index82UtF9N8oEMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/panel/index.vue").then(m => m.default || m)
  },
  {
    name: "panel-prompt-add",
    path: "/panel/prompt/add",
    meta: addtbRCc3tf7NMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/panel/prompt/add.vue").then(m => m.default || m)
  },
  {
    name: "panel-prompt",
    path: "/panel/prompt",
    meta: indexgCNVGbJTfaMeta || {},
    component: () => import("/media/saeid/projects/Athena/client/app/pages/panel/prompt/index.vue").then(m => m.default || m)
  }
]